import { createAsyncThunk } from "@reduxjs/toolkit";
import { corporateClientsAPI } from "api/api/corporateClientsApi/corporateClientsApi";
import axios from "axios";
import { GetCorporateClientsParams, GetCorporateClientsRes } from "api/api/corporateClientsApi/types";

export const getCorporateClients = createAsyncThunk<
  GetCorporateClientsRes,
  GetCorporateClientsParams
>(
  `statuses/getStatusesComments`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await corporateClientsAPI.getCorporateClients(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting statuses comments",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting statuses comments", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
